import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import editIconActive from '../../../images/insight360/edit-icon_active.png';
import filterIconActive from '../../../images/insight360/filter-icon_active.png';
import infoIconWhite from '../../../images/insight360/info-icon_white.png';
import clearFilterIcon from '../../../images/insight360/clear-field-icon_white.png';
import {
  WEIGHTED_INFO_MSG,
  REACH_INFO_MSG,
  SAMPLE_INFO_MSG,
} from '../../../messages/messages';
import {
  WEIGHTED_LABEL,
  REACH_LABEL,
  SELECTED_FILTER_LABEL,
  LENGHTOF_PDF_LABEL,
  SAMPLE_LABEL,
  REMOVE_PERSONA_CLICK,
  CHANGE_FILTER_FROM_HEADER,
} from '../../../constants';
import DemographicFilter from './DemographicFilter';
import Modal from '../../common/Modal/Modal';
import GenericButton from '../../common/GenericButton';
import { numberWithCommas, nthOccurrence } from '../../../util/CommonUtils';
import InlineEdit from '../../common/InlineEdit/InlineEdit';

const modalWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

class DemographicTripleComparisionHeaderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteractive: false,
      selectedFilterOption: undefined,
      selectedFilterOptionToolTip: undefined,
      insight360PersonaFixedHeaderChoice: false,
      weight: this.props.weight !== undefined ? this.props.weight : 0,
      sample: this.props.sample !== undefined ? this.props.sample : 0,
      pct: this.props.pct !== undefined ? this.props.pct : 0,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.personaFilter !== undefined &&
      nextProps.index !== undefined
    ) {
      const filter = nextProps.personaFilter[nextProps.index];
      const label = this.findFilterLabel([filter]);
      if (label !== undefined) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      }
      const emptyIndex = nextProps.personaFilter.filterIndex;
      if (nextProps.personaFilter[emptyIndex] === '') {
        this.setState({ selectedFilterOption: undefined });
        this.setState({ selectedFilterOptionToolTip: undefined });
      }
    }

    if (
      nextProps.insight360PersonaFilter !== undefined &&
      nextProps.index !== undefined
    ) {
      const filter = nextProps.insight360PersonaFilter[nextProps.index];
      const label = this.findFilterLabel([filter]);
      if (label !== undefined) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      }
    }

    if (
      nextProps.insight360PersonaFixedHeaderChoice !== undefined &&
      this.props.insight360PersonaFixedHeaderChoice !==
        nextProps.insight360PersonaFixedHeaderChoice
    ) {
      this.setState({
        insight360PersonaFixedHeaderChoice:
          nextProps.insight360PersonaFixedHeaderChoice,
      });
    }

    if (
      nextProps.weight !== undefined &&
      this.props.weight !== nextProps.weight
    ) {
      this.setState({ weight: nextProps.weight });
    }

    if (
      nextProps.sample !== undefined &&
      this.props.sample !== nextProps.sample
    ) {
      this.setState({ sample: nextProps.sample });
    }

    if (nextProps.pct !== undefined && this.props.pct !== nextProps.pct) {
      this.setState({ pct: nextProps.pct });
    }
  }

  componentDidMount() {
    this.didMountMethod();
  }

  didMountMethod = () => {
    if (
      this.props.insight360PersonaFilter !== undefined &&
      this.props.index !== undefined
    ) {
      const filter = this.props.insight360PersonaFilter[this.props.index];
      const label = this.findFilterLabel([filter]);
      if (label !== undefined) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      }
    }
  }

  handleFilterClick = () => {
    this.setState({ filteractive: !this.state.filteractive });
  };

  handleRemoveDemographicClick = () => {
    this.modalWarining.show();
    // this.props.removeDemographic(this.props.index);
  };

  handleClearFilterClick = () => {
    this.setState({ selectedFilterOption: undefined });
    this.setState({ selectedFilterOptionToolTip: undefined });
    this.props.filterExpressionChanged([''], this.props.index);
  };

  handleFilterExpressionChanged = filter => {
    if (
      (filter.length > 0 && this.state.selectedFilterOption === undefined) ||
      (filter.length > 0 &&
        filter[0] !== this.state.selectedFilterOption.keyword)
    ) {
      this.props.trackerFn({ action: CHANGE_FILTER_FROM_HEADER });
      this.props.filterExpressionChanged(filter, this.props.index);
      this.handleFilterClick();
      // find the filter label and store it in state
      const label = this.findFilterLabel(filter);
      if (
        label !== undefined &&
        label.title !== undefined &&
        label.title.length > 0
      ) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      } else {
        this.setState({ selectedFilterOption: undefined });
        this.setState({ selectedFilterOptionToolTip: undefined });
      }
    } else {
      this.handleFilterClick();
    }
  };

  findFilterLabel = filter => {
    if (this.props.filterOptions !== undefined) {
      const y = this.props.filterOptions.data;
      const z = _.flatMap(y);
      return _.find(z, { keyword: filter[0] });
    }
  };

  getIndexOfPdfLabel = () => {
    let lenghtOfPdfLabel = LENGHTOF_PDF_LABEL;
    const nthOccurrenceIndex = nthOccurrence(this.props.label, ')', 2);
    if (
      nthOccurrenceIndex < lenghtOfPdfLabel &&
      nthOccurrenceIndex !== -1 &&
      nthOccurrenceIndex !== 'undefined'
    ) {
      lenghtOfPdfLabel = nthOccurrenceIndex + 1;
    } else {
      lenghtOfPdfLabel = this.props.label.length;
    }
    return lenghtOfPdfLabel;
  };

  render() {
    const filter = this.props.personaFilter[this.props.index];
    const label = this.findFilterLabel([filter]);
    let selectedFilter;
    if (label !== undefined) {
      selectedFilter = label;
    }
    return (
      <div>
        <Modal
          title=""
          ref={node => (this.modalWarining = node)}
          dialogStyles={modalWariningStyle}
        >
          <div className="text-center">
            <p>This is going to delete this Selection</p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => {
                this.props.trackerFn({ action: REMOVE_PERSONA_CLICK });
                this.props.removeDemographic(this.props.index);
                this.modalWarining.hide();
              }}
            />
          </div>
        </Modal>
        {this.props.expression !== undefined && (
          <div>
            <div className="div-overflow">
              <div className="demographic-float persona-info-container-triple">
                <div className="inlineEditFlag persona-info triple-info">
                  <InlineEdit
                    textVal={this.props.label}
                    editBlockWidth="100%"
                    icon={editIconActive}
                    updateFn={this.props.personaHeaderLabelUpdate}
                    validateFn={this.props.personaHeaderLabelValidate}
                    index={this.props.index}
                  />

                  <span style={{ position: 'absolute' }}>
                    <img
                      className="i360_header_icons_img"
                      src={filterIconActive}
                      alt="filter"
                      onClick={() => {
                        this.handleFilterClick();
                      }}
                    />
                    {this.props.filterOptions !== undefined &&
                      this.state.filteractive && (
                      <DemographicFilter
                        filterOptions={this.props.filterOptions}
                        filterExpressionChanged={
                          this.handleFilterExpressionChanged
                        }
                        index={this.props.index}
                        filterCssClass={
                          this.state.filteractive
                            ? `${(this.state.filteractive && this.state.insight360PersonaFixedHeaderChoice) ===
                            true ? 'fixed-filter-active' : 'filter-active'}` : 'filter-hidden'
                        }
                        personaFilter={this.props.personaFilter}
                      />
                      )}
                  </span>
                </div>

                <div className="persona-info double-info">
                  <span className="pdfTriplePersonaHeaderLabelFlag LabelBlock">
                    {this.props.label.substring(0, this.getIndexOfPdfLabel())}
                  </span>
                </div>

                <div>
                  {(this.state.selectedFilterOption !== undefined &&
                    this.state.selectedFilterOption.title !== undefined &&
                    this.state.selectedFilterOption.title.length > 0) ||
                  (selectedFilter !== undefined &&
                    selectedFilter.title !== undefined &&
                    selectedFilter.title.length > 0) ? (
                    <span className="persona-filter-display">
                      <strong>{`${SELECTED_FILTER_LABEL}: `}</strong>
                      <span className="persona-filter-label-el pdf-triple-persona-filter-label-el">
                        <span
                          data-tooltip
                          aria-haspopup="true"
                          id="filterLabelFlag"
                          className="label-ellipsis"
                          title={
                            this.state.selectedFilterOption !== undefined &&
                            this.state.selectedFilterOption.title !==
                              undefined &&
                            this.state.selectedFilterOption.title.length > 0
                              ? this.state.selectedFilterOptionToolTip.title
                              : selectedFilter.title
                          }
                        >
                          {this.state.selectedFilterOption !== undefined &&
                          this.state.selectedFilterOption.title !== undefined &&
                          this.state.selectedFilterOption.title.length > 0
                            ? this.state.selectedFilterOption.title
                            : selectedFilter.title}
                        </span>
                      </span>
                      <img
                        className="i360_header_icons_img"
                        src={clearFilterIcon}
                        alt="Remove"
                        onClick={() => this.handleClearFilterClick()}
                      />
                    </span>
                  ) : (
                    <span className="persona-filter-display">&nbsp;</span>
                  )}
                </div>
              </div>

              <div className="demographic-float-right float-right">
                <img
                  className="i360_header_icons_img"
                  src={clearFilterIcon}
                  alt="Remove"
                  onClick={() => {
                    this.handleRemoveDemographicClick();
                  }}
                />
              </div>
            </div>
            <div className="row margin-bottom-10 padding-left-15">
              <div className="columns small-3 data-comparision-tb-section">
                <div className="comparision-info-label">
                  {SAMPLE_LABEL}
                  <img
                    className="i360_header_icons_img size-sm"
                    src={infoIconWhite}
                    alt={SAMPLE_INFO_MSG}
                    title={SAMPLE_INFO_MSG}
                  />
                </div>
                <div className="pdf-data-comparision-tb-section">
                  {numberWithCommas(Math.round(this.state.sample))}
                </div>
              </div>

              <div className="columns small-5 data-comparision-tb-section">
                <div className="comparision-info-label">
                  {WEIGHTED_LABEL}
                  <img
                    className="i360_header_icons_img size-sm"
                    src={infoIconWhite}
                    alt={WEIGHTED_INFO_MSG}
                    title={WEIGHTED_INFO_MSG}
                  />
                </div>
                <div className="pdf-data-comparision-tb-section">
                  {numberWithCommas(Math.round(this.state.weight))}
                </div>
              </div>
              <div className="columns small-4 data-comparision-tb-section">
                <div className="comparision-info-label">
                  {REACH_LABEL}
                  <img
                    className="i360_header_icons_img size-sm"
                    src={infoIconWhite}
                    alt={REACH_INFO_MSG}
                    title={REACH_INFO_MSG}
                  />
                </div>
                <div className="pdf-data-comparision-tb-section">
                  {Math.round(this.state.pct * 10) / 10}%
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  /* getImageIcon(imageKey) {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    } else {
      // code to return default image
    }
  } */
}

DemographicTripleComparisionHeaderInfo.propTypes = {
  filterExpressionChanged: PropTypes.func,
  index: PropTypes.number,
  removeDemographic: PropTypes.func,
  personaFilter: PropTypes.arrayOf(PropTypes.string),
  insight360PersonaFilter: PropTypes.arrayOf(PropTypes.string),
  expression: PropTypes.string,
  label: PropTypes.string,
  pct: PropTypes.number,
  weight: PropTypes.number,
  sample: PropTypes.number,
  insight360PersonaFixedHeaderChoice: PropTypes.bool,
  trackerFn: PropTypes.func,
};

// function mapDispatchToProps() {
//   return {
//     // insight360Actions: bindActionCreators(insight360Actions, dispatch),
//   };
// }

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    insight360PersonaFilter: state.insight360.insight360PersonaFilter,
    insight360PersonaFixedHeaderChoice:
      state.insight360.insight360PersonaFixedHeaderChoice,
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true },
)(DemographicTripleComparisionHeaderInfo);
